import InputField from "../../../components/InputField";
import SelectField from "../../../components/SelectField";
import TextareaField from "../../../components/TextareaField";
import Toggle from "../../../components/Toggle";

const monedaOptions = [
  { value: "RON", label: "RON" },
  { value: "EUR", label: "EUR" },
];

const sectionHeader = {
  fontSize: "15px",
  fontWeight: 700,
  color: "#2d2418",
  fontFamily: "'DM Sans', sans-serif",
  margin: "0 0 12px 0",
  paddingBottom: "8px",
  borderBottom: "1px solid #e8e0d4",
};

export default function ModificariStep({ data, errors, update }) {
  const multipleSelected = [data.prelungire, data.modificareChirie, data.modificareClauze].filter(Boolean).length > 1;

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "24px" }}>
      {data.prelungire && (
        <div>
          {multipleSelected && <p style={sectionHeader}>Prelungirea contractului</p>}
          <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
            <Toggle
              label="Prelungire pe perioadă nedeterminată"
              description="Contractul se prelungește fără o dată fixă de încetare"
              checked={!!data.prelungireNedeterminata}
              onChange={() => update("prelungireNedeterminata")(!data.prelungireNedeterminata)}
            />
            {!data.prelungireNedeterminata && (
              <InputField
                label="Noua dată de încetare"
                value={data.nouaDataIncetare}
                onChange={update("nouaDataIncetare")}
                type="date"
                required
                error={errors.nouaDataIncetare}
              />
            )}
          </div>
        </div>
      )}

      {data.modificareChirie && (
        <div>
          {multipleSelected && <p style={sectionHeader}>Modificarea chiriei</p>}
          <div style={{ display: "flex", flexWrap: "wrap", gap: "16px" }}>
            <InputField
              label="Chiria veche"
              value={data.chirieVeche}
              onChange={update("chirieVeche")}
              placeholder="ex: 500"
              type="number"
              required
              half
              error={errors.chirieVeche}
            />
            <SelectField
              label="Moneda"
              value={data.chirieVecheMoneda}
              onChange={update("chirieVecheMoneda")}
              options={monedaOptions}
              half
            />
            <InputField
              label="Chiria nouă"
              value={data.chirieNoua}
              onChange={update("chirieNoua")}
              placeholder="ex: 600"
              type="number"
              required
              half
              error={errors.chirieNoua}
            />
            <SelectField
              label="Moneda"
              value={data.chirieNouaMoneda}
              onChange={update("chirieNouaMoneda")}
              options={monedaOptions}
              half
            />
            <InputField
              label="Data de la care se aplică"
              value={data.dataAplicareChirie}
              onChange={update("dataAplicareChirie")}
              type="date"
              required
              error={errors.dataAplicareChirie}
            />
          </div>
        </div>
      )}

      {data.modificareClauze && (
        <div>
          {multipleSelected && <p style={sectionHeader}>Modificarea altor clauze</p>}
          <TextareaField
            label="Descrieți modificarea dorită"
            value={data.descriereModificare}
            onChange={update("descriereModificare")}
            placeholder="Se modifică art. 5.2 din contract astfel: ..."
            required
            error={errors.descriereModificare}
          />
        </div>
      )}
    </div>
  );
}
